export const ScheduledExternalTransferHeaderElements = [
  { label: "Fecha programada", value: "fechaEjecucion", align: "inherit" },
  { label: "Titular cuenta", value: "titular", align: "inherit" },
  { label: "N° Cuenta", value: "cuenta", align: "inherit" },
  { label: "Cuenta destino", value: "cuentaDestino", align: "inherit" },
  { label: "Monto", value: "monto", align: "inherit" },
  { label: "Solicitante", value: "usuarioCrea", align: "inherit" },
  { label: "Estado", value: "displayEstado", align: "inherit" },
];
